<template>
    <div></div>
</template>

<script>
export default {
    created() {
        window.auth.login();
    }
};
</script>
